import { Link } from "react-router-dom";
import { useDocumentMeta } from "../hooks/useDocumentMeta";

const LINKS = [
    ["/actualites", "Nos décryptages"],
    ["/tarifs", "Tarifs"],
    ["/faq", "FAQ"],
    ["/contact", "Contact"],
];

export default function NotFound() {
    useDocumentMeta({
        title: "Page introuvable — FOD by DMB Partners",
        description: "Cette page n'existe pas ou a été déplacée.",
        noindex: true,
    });

    return (
        <section data-testid="not-found-page" className="bg-navy text-cream">
            <div className="mx-auto max-w-[1180px] px-4 md:px-8 lg:px-12 py-16 md:py-24 lg:py-32 flex flex-wrap gap-x-16 gap-y-10 items-center">
                <div className="flex-[999_1_520px] min-w-0 flex flex-col gap-[22px] animate-fade-up">
                    <div className="text-[13px] font-semibold uppercase tracking-[0.16em] text-gold">Erreur 404</div>
                    <h1 className="m-0 font-bold text-[32px] md:text-5xl lg:text-[60px] leading-[1.12] tracking-[-0.025em] text-cream">
                        Cette ligne n'apparaît <span className="text-gold">sur aucun relevé.</span>
                    </h1>
                    <div className="w-40 h-1.5 bg-gold" />
                    <p className="m-0 text-base md:text-lg leading-relaxed text-on-navy max-w-[560px]">
                        La page que vous cherchez n'existe pas ou a été déplacée. Vos économies, elles, sont toujours à portée de clic.
                    </p>
                    <div className="flex flex-wrap gap-3">
                        <Link to="/" data-testid="not-found-home-link" className="inline-flex items-center justify-center h-[52px] px-6 rounded-md border border-white text-white text-base font-semibold transition-colors hover:bg-white hover:text-navy">
                            Retour à l'accueil
                        </Link>
                        <Link to="/simulateur" data-testid="not-found-simulator-link" className="inline-flex items-center justify-center h-[52px] px-6 rounded-md bg-gold text-navy text-base font-semibold transition-[transform,box-shadow] hover:-translate-y-[1px] hover:shadow-lg">
                            Simuler mes économies
                        </Link>
                    </div>
                </div>
                <nav aria-label="Pages utiles" className="flex-1 basis-[260px] min-w-0 flex flex-col border-t border-navy-outline">
                    {LINKS.map(([to, label]) => (
                        <Link key={to} to={to} data-testid={`not-found-link-${to.slice(1)}`} className="group flex items-center justify-between py-4 border-b border-navy-outline text-[17px] font-semibold text-cream hover:text-gold transition-colors">
                            {label}
                            <span aria-hidden="true" className="transition-transform group-hover:translate-x-1">→</span>
                        </Link>
                    ))}
                </nav>
            </div>
        </section>
    );
}
